import type { InventoryInspectionOutput } from "./types";

type SectionLike = {
  id: string;
  key: string;
  title?: string | null;
};

export const extractSectionId = (
  inspection: Pick<InventoryInspectionOutput, "sections"> | { sections?: SectionLike[] },
  sectionKey: string,
  fallback?: { id?: string; title?: string }
): string | undefined => {
  const sections = inspection.sections ?? [];
  const match =
    sections.find((s) => s.key === sectionKey) ??
    (fallback?.id ? sections.find((s) => s.id === fallback.id) : undefined) ??
    (fallback?.title ? sections.find((s) => s.title === fallback.title) : undefined);

  return match?.id;
};
